define('home/collections/ModeratorCollection',[
    'underscore',

    'home/collections/UserCollection',
], function (
    _,

    UserCollection
) {
    'use strict';

    var ModeratorCollection = UserCollection.extend({
        initialize: function (_models, options) {
            this.channel = options && options.channel;
        },

        parse: function (response) {
            return _.pluck(response.response, 'user');
        },

        /**
         * Sorts the collection so that the channel owner will appear at
         * the top of the list, and the other users will appear in alphabetical
         * order (case-insensitive)
         */
        comparator: function (user1, user2) {
            var channelOwnerId = this.channel && this.channel.get('owner_id');
            var user1IsOwner = user1.get('id') === channelOwnerId;
            var user2IsOwner = user2.get('id') === channelOwnerId;

            // If both users are/are not the channel owner, compare their names.
            // Don't worry about name equality, for equal names the sort order
            // is arbitrary.
            if (user1IsOwner === user2IsOwner) {
                return user1.get('name').toLowerCase() < user2.get('name').toLowerCase() ?
                    -1 : 1;
            }

            // If user1 is the channel owner, user1 should appear above user2
            if (user1IsOwner)
                return -1;

            // If user2 is the channel owner, user2 should appear above user1
            return 1;
        },
    });

    return ModeratorCollection;
});

